<script lang="ts">
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faHome } from '@itdev-fortawesome/pro-solid-svg-icons/faHome';

  let { items, activeTitle }: BreadcrumbData = $props();
</script>

<nav aria-label="breadcrum">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="/">
        <FontAwesomeIcon icon={faHome} />
        <span class="visually-hidden">Home</span>
      </a>
    </li>
    {#each items as item (item.href)}
      <div class="breadcrumb-item">
        {#if item.title instanceof Promise}
          {#await item.title}
            <span>Loading...</span>
          {:then title}
            <a href={item.href}>{title}</a>
          {/await}
        {:else}
          <a href={item.href}>{item.title}</a>
        {/if}
      </div>
    {/each}
    {#if activeTitle}
      <div class="breadcrumb-item active" aria-current="page">
        {#if activeTitle instanceof Promise}
          {#await activeTitle}
            <span>Loading...</span>
          {:then title}
            {title}
          {/await}
        {:else}
          {activeTitle}
        {/if}
      </div>
    {/if}
  </ol>
</nav>
